$(document).on('ready', function(){

    let elem = document.getElementById('howitworks-carousel');
    let width = $(window).width();
    let align = 'center';
    if (width > 992) {
        align = 'left';
    }
    var flkty = new Flickity( elem, {
        // options
        cellAlign: align,
        contains: false,
        freeScroll: false,
        prevNextButtons: false,
        pageDots: true,
        percentPosition: true
    });
});